import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import s from './PopularLocation.css';
import l from '../../Skeleton/Skeleton.css';

// Components
import PopularLocationSlider from '../PopularLocationSlider';

// Skeleton Loader
import Shimmer from "../../Skeleton/Shimmer";
import HomePopularSkeleton from "../../Skeleton/HomePopularSkeleton";

// GraphQL
import { getPopularLocationQuery } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

// Locale
import messages from '../../../locale/jsonMessages';

function PopularLocation({ getPopularLocationData }) {
  const loading = getPopularLocationData?.loading;
  const data = getPopularLocationData?.getPopularLocationAdmin || [];

  return (
    <>
      {loading ? (
        <div className={cx('bgBlackTwo')}>
          <div className={s.container}>
            <div className={cx(l.popularSkeletonTwoTitle, 'bgBlackTwo')}>
              <Shimmer />
            </div>
            <div className={s.displayGridTwo}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <HomePopularSkeleton key={n} />
              ))}
            </div>
          </div>
        </div>
      ) : (
        data.length > 0 && (
          <div className={s.topBottomCss}>
            <div className={s.container}>
              <h3 className={cx(s.containerTitle)}>
                <FormattedMessage {...messages.popularLocation} />
              </h3>
              <PopularLocationSlider data={data} />
            </div>
          </div>
        )
      )}
    </>
  );
}

PopularLocation.propTypes = {
  getPopularLocationData: PropTypes.shape({
    loading: PropTypes.bool,
    getPopularLocationAdmin: PropTypes.array
  }),
};

PopularLocation.defaultProps = {
  getPopularLocationData: {
    loading: true
  }
};

export default compose(
  injectIntl,
  withStyles(s, l),
  withQuery(getPopularLocationQuery, {
    name: 'getPopularLocationData',
    options: {
      ssr: false
    }
  }),
)(PopularLocation);
